import type { IFieldConfig, IFormKitControlProps } from './types'

export const genDataField =
  <D>() =>
  <P extends IFormKitControlProps<D[N]>, N extends string & keyof D>(
    config: Omit<IFieldConfig<D, P, N>, '__type'>,
  ): IFieldConfig =>
    ({ ...config, __type: 'UIField' }) as unknown as IFieldConfig

export const genFieldUnsafe = <P>(config: Omit<IFieldConfig<unknown, P>, '__type'>): IFieldConfig =>
  ({ ...config, __type: 'UIField' }) as IFieldConfig

export const genGroupField = <D>(
  c: Omit<IFieldConfig<D>, 'as' | 'name' | '__type'>,
): IFieldConfig => ({ ...c, __type: 'UIFieldGroup' }) as IFieldConfig
